const NotFound = () => {
    return (
      <div>
        <strong>404 Not Found</strong>
        <p>Page not found. Please go back and try again.</p>
      </div>
    );
  };
  
  export default NotFound;